<cb-dialog class="flex-fill" [fullscreen]="true"
           [dialogHeading]="data.lotDto.jobNumber + ' - Lot Build Programme'">
    <cb-lot-build-programme-view class="flex-fill"
                                 [lotDto]="data.lotDto"
                                 [fullscreen]="true"></cb-lot-build-programme-view>
</cb-dialog>
